module.exports = __webpack_public_path__ + "img/memo.d0206252.png";